import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import styles from './SupportCategoryModal.module.scss';
import closeIcon from '../../constants/images/close-dark.svg';
import {supportActions} from "../../store/slices/supportSlice";
import {MAIN_ROUTES} from "../../routing/main_routes";

const CATEGORIES = [
    {value: 'payment', label: 'Оплата'},
    {value: 'quality', label: 'Якість прибирання'},
    {value: 'no_show', label: 'Неявка'},
    {value: 'behavior', label: 'Поведінка'},
    {value: 'reschedule_cancel', label: 'Перенесення / скасування'},
    {value: 'damage', label: 'Пошкодження майна'},
    {value: 'other', label: 'Інше'},
];

const SupportCategoryModal = ({open, onClose, orderId}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {status, error} = useSelector((state) => state.support);

    const [category, setCategory] = useState('');
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [validationError, setValidationError] = useState('');

    const resetForm = () => {
        setCategory('');
        setSubject('');
        setBody('');
        setValidationError('');
        dispatch(supportActions.clearError());
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!category) {
            setValidationError('Оберіть категорію звернення');
            return;
        }
        if (!body.trim()) {
            setValidationError('Введіть текст повідомлення');
            return;
        }

        setValidationError('');

        const ticketData = {
            category,
            body: body.trim(),
        };
        if (subject.trim()) {
            ticketData.subject = subject.trim();
        }
        if (orderId) {
            ticketData.order = orderId;
        }

        try {
            const resultAction = await dispatch(supportActions.createTicket(ticketData));
            if (supportActions.createTicket.fulfilled.match(resultAction)) {
                const ticket = resultAction.payload;
                handleClose();
                navigate(`${MAIN_ROUTES.SUPPORT_CHAT}/${ticket.id}`);
            }
        } catch (err) {
            console.error(err);
        }
    };

    if (!open) {
        return null;
    }

    const isSubmitting = status === 'loading';

    return (
        <>
            <div className={styles.overlay} onClick={handleClose}/>
            <div className={styles.modal} role="dialog" aria-modal="true">
                <div className={styles.modal_header}>
                    <p className={styles.modal_header_title}>Нове звернення</p>
                    <button className={styles.modal_header_close} onClick={handleClose} aria-label="Закрити">
                        <img src={closeIcon} alt="закрити"/>
                    </button>
                </div>

                <form className={styles.modal_form} onSubmit={handleSubmit} noValidate>
                    <div className={styles.modal_form_field}>
                        <label className={styles.modal_form_field_label} htmlFor="support-category">
                            Категорія *
                        </label>
                        <select
                            id="support-category"
                            className={styles.modal_form_field_select}
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            required
                        >
                            <option value="">Оберіть категорію</option>
                            {CATEGORIES.map((cat) => (
                                <option key={cat.value} value={cat.value}>
                                    {cat.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={styles.modal_form_field}>
                        <label className={styles.modal_form_field_label} htmlFor="support-subject">
                            Тема (необов'язково)
                        </label>
                        <input
                            id="support-subject"
                            type="text"
                            className={styles.modal_form_field_input}
                            placeholder="Коротко опишіть проблему"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            maxLength={200}
                        />
                    </div>

                    <div className={styles.modal_form_field}>
                        <label className={styles.modal_form_field_label} htmlFor="support-body">
                            Повідомлення *
                        </label>
                        <textarea
                            id="support-body"
                            className={styles.modal_form_field_textarea}
                            placeholder="Детально опишіть вашу ситуацію"
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            required
                        />
                    </div>

                    {(validationError || error) && (
                        <p className={styles.modal_error}>{validationError || error}</p>
                    )}

                    <div className={styles.modal_form_actions}>
                        <button
                            type="button"
                            className={styles.modal_form_actions_cancel}
                            onClick={handleClose}
                        >
                            Скасувати
                        </button>
                        <button
                            type="submit"
                            className={styles.modal_form_actions_submit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Надсилання...' : 'Надіслати'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default SupportCategoryModal;
